import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// import de from "./locales/de.json";
import en from "./locales/en.json";
import vi from "./locales/vi.json";

const resources = {
  vi: {
    translation: vi,
  },
  en: {
    translation: en,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("loyalty-lng") || "vi",
    fallbackLng: "vi",
    supportedLngs: ["vi", "en"],
    debug: true,
    detection: {
      order: ["localStorage", "cookie"],
      lookupLocalStorage: "loyalty-lng",
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
